













import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryHouseList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import CreateHouseDialog from './CreateHouseDialog.vue'
import ImportHouseDialog from './ImportHouseDialog.vue'
import HouseDescDialog from './HouseDescDialog.vue'
import UpdateHouseDialog from './UpdateHouseDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    CreateHouseDialog,
    ImportHouseDialog,
    HouseDescDialog,
    UpdateHouseDialog,
  },
})
export default class HouseList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '户号', param: 'houseAccount' },
    { title: '小区名称', param: 'communityName' },
    { title: '客户手机号', param: 'reservedMobilePhone' },
    { title: '业主姓名', param: 'reservedName' },
    { title: '用户手机号', param: 'mobilePhone' },
    { title: '用户姓名', param: 'nickname' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '创建户主', type: 'primary', click: this.createHouse },
    { title: '导入户主信息', type: 'primary', click: this.importHouse },
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '户号', param: 'houseAccount' },
    { title: '小区名称', param: 'communityName' },
    { title: '客户手机号', param: 'reservedMobilePhone' },
    { title: '业主姓名', param: 'reservedName' },
    { title: '用户手机号', param: 'mobilePhone' },
    { title: '用户姓名', param: 'nickname' },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      operation: [
        { title: '查看详情', icon: 'el-icon-document', click: this.openDesc },
        { title: '修改', icon: 'el-icon-edit', click: this.openUpdate},
        // { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  public createHouse() {
    (this.$refs.createHouseDialog as CreateHouseDialog).open()
  }

  public importHouse() {
    (this.$refs.importHouseDialog as ImportHouseDialog).open()
  }
  public openDesc(data: any) {
    (this.$refs.houseDescDialog as HouseDescDialog).open(data.houseCode)
  }
  public openUpdate(data: any) {
    (this.$refs.updateHouseDialog as UpdateHouseDialog).open(data.houseCode)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryHouseList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  // public deleteRow(data: any) {
  //   MessageBox.confirm('确定要删除吗？', '提示', {
  //     type: 'warning',
  //   }).then(async () => {
  //     const ruslt = await DeleteActivity({ id: data.id })
  //     if (ruslt) {
  //       Message.success('删除成功')
  //       this.loadData()
  //     }
  //   })
  // }
}
